// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".waveform{display:flex;align-items:center;height:100%;width:80%;justify-content:space-between}.waveform .bar{width:2px;height:0;background:#fff;transition:all .2s}", ""]);
// Exports
module.exports = exports;
